(() => {
  if (customElements.get('strike-related-products')) return;
  class StrikeRelatedProducts extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.button = document.querySelector(`[data-product-related-jump][data-related-product="${this.dataset.productId}"]`);
      this.prompt = document.querySelector(`[data-product-related-prompt][data-related-product="${this.dataset.productId}"]`);
      this.sync();
      this.button?.addEventListener('click', event => {
        event.preventDefault();
        this.sync();
        if (this.button.hidden) return;
        this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        this.querySelector('h2')?.focus({ preventScroll: true });
      });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'href'] });
      this.load();
    }
    sync() {
      const available = !this.hidden && !!this.querySelector('.product-grid .grid__item a[href*="/products/"]');
      if (this.button) this.button.hidden = !available;
      if (this.prompt) this.prompt.hidden = !available;
    }
    async load() {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const url = new URL(this.dataset.url, location.origin);
        if (url.origin !== location.origin) return;
        url.searchParams.set('product_id', this.dataset.productId);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('strike-related-products');
        if (content) this.innerHTML = content.innerHTML;
        this.sync();
      } catch (_) {
        this.sync();
      } finally {
        clearTimeout(timeout);
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  customElements.define('strike-related-products', StrikeRelatedProducts);
})();
